import { useGetContentByFriendlyUrlQuery } from '@/redux/api/contentDeliveryAPI';
import { IContentExtended } from '@/lib/helpers/expandChildren';
import { simpleHash } from '@/utils/helpers';

const Domain = '.pli.edu';

type UseGetEcommPanelContentReturn = {
  content?: IContentExtended;
  isLoadingContent: boolean;
  isError?: boolean;
};

const useGetEcommPanelContent = (url?: string): UseGetEcommPanelContentReturn => {
  const friendlyUrl = url?.includes(Domain) ? url.split(Domain)[1] : url;

  const {
    data: content,
    isFetching: isLoadingContent,
    isError
  } = useGetContentByFriendlyUrlQuery(
    { friendlyUrl: friendlyUrl ?? '', userId: simpleHash('ANON') },
    { skip: !friendlyUrl }
  );

  return { content, isLoadingContent, isError };
};

export default useGetEcommPanelContent;
